import { Link } from 'react-router-dom';

const LOGO_URL = 'https://static.readdy.ai/image/81164d3ba0f00c2a7e247a9f180c9b75/f0fddf85d747fa5ad2e4c99896af0d57.png';

const collections = [
  { label: 'Living Room', path: '/collections/living-room' },
  { label: 'Bedroom', path: '/collections/bedroom' },
  { label: 'Dining Room', path: '/collections/dining-room' },
  { label: 'Home Office', path: '/collections/home-office' },
  { label: 'Outdoor', path: '/collections/outdoor' },
];

const companyLinks = [
  { label: 'About Us', path: '/about' },
  { label: 'Photo Gallery', path: '/gallery' },
  { label: 'Visit Showroom', path: '/showroom' },
  { label: 'Customer Reviews', path: '/reviews' },
  { label: 'FAQ', path: '/faq' },
  { label: 'Contact Us', path: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-dark text-white pt-20 pb-8 relative overflow-hidden">
      {/* Background wordmark */}
      <div className="absolute bottom-0 left-0 right-0 flex items-end justify-center pointer-events-none select-none overflow-hidden">
        <span className="text-[140px] font-serif font-black text-white/[0.025] leading-none tracking-tighter whitespace-nowrap">
          ECLECTIC
        </span>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 pb-16 border-b border-white/10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img
                src={LOGO_URL}
                alt="Eclectic Contracting"
                className="h-12 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              Premium furniture and interiors for the modern home. Curated with care, crafted to last.
            </p>
            <div className="flex flex-col gap-3 text-sm">
              <a href="tel:7028509900" className="flex items-center gap-2 text-white/60 hover:text-gold transition-colors cursor-pointer">
                <i className="ri-phone-fill text-gold text-xs" />
                (702) 850-9900
              </a>
              <a href="mailto:hello@eclectichome.com" className="flex items-center gap-2 text-white/60 hover:text-gold transition-colors cursor-pointer">
                <i className="ri-mail-fill text-gold text-xs" />
                hello@eclectichome.com
              </a>
              <span className="flex items-center gap-2 text-white/60">
                <i className="ri-map-pin-fill text-gold text-xs" />
                3750 S Las Vegas Blvd, Las Vegas, NV
              </span>
            </div>
          </div>

          {/* Collections */}
          <div>
            <h4 className="text-white font-semibold text-xs uppercase tracking-[0.2em] mb-6">Collections</h4>
            <ul className="space-y-3">
              {collections.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-white/50 text-sm hover:text-gold transition-colors flex items-center gap-2 cursor-pointer">
                    <span className="w-3 h-px bg-gold/40 inline-block" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold text-xs uppercase tracking-[0.2em] mb-6">Company</h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-white/50 text-sm hover:text-gold transition-colors flex items-center gap-2 cursor-pointer">
                    <span className="w-3 h-px bg-gold/40 inline-block" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Showroom + Hours */}
          <div>
            <h4 className="text-white font-semibold text-xs uppercase tracking-[0.2em] mb-6">Showroom Hours</h4>
            <div className="space-y-3 mb-8">
              {[
                { day: 'Mon – Fri', time: '10am – 7pm' },
                { day: 'Saturday', time: '10am – 6pm' },
                { day: 'Sunday', time: '11am – 5pm' },
              ].map((item) => (
                <div key={item.day} className="flex justify-between text-sm border-b border-white/8 pb-3">
                  <span className="text-white/50">{item.day}</span>
                  <span className="text-white/80 font-medium">{item.time}</span>
                </div>
              ))}
            </div>
            <div className="flex gap-3">
              {['ri-instagram-line', 'ri-pinterest-line', 'ri-facebook-circle-line', 'ri-houzz-fill'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow noopener"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/15 text-white/40 hover:border-gold hover:text-gold transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            © {new Date().getFullYear()} Eclectic Home. All rights reserved. Las Vegas, Nevada.
          </p>
          <div className="flex gap-6">
            {['Privacy Policy', 'Terms of Service', 'Shipping & Returns'].map((item) => (
              <a key={item} href="#" rel="nofollow" className="text-white/30 text-xs hover:text-white/60 transition-colors cursor-pointer">{item}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
